import { breadcrumb } from './breadcrumb';

export const hlr = {
  breadcrumb,

  requests: {
    index: 'Meminta',
    create_request: 'Buat permintaan',

    status: {
      pending: 'Tunda',
      processing: 'Proses',
      rejected: 'Ditolak',
      failed: 'Gagal',
      success: 'Berhasil'
    },
    download: {
      tooltip: 'Ekspor'
    },
    upload: {
      success: 'Permintaan berhasil dibuat'
    }
  }
};
